import { TutorialBoxProps } from "./types";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { HelpCircle } from "lucide-react";

export function TutorialBox({ children, title, help }: TutorialBoxProps) {
  return (
    <div
      className={cn(
        "relative rounded-2xl border border-cede-border-container/60 bg-information-card-background px-6 pt-10 pb-6 text-left shadow-sm backdrop-blur-sm",
      )}
    >
      <h2 className="absolute left-1/2 top-0 inline-flex -translate-x-1/2 -translate-y-1/2 items-center rounded-full bg-gradient-to-r from-[#5ea6ff] to-[#75b3ff] px-5 py-1 text-sm font-semibold text-white shadow-lg shadow-cede-primary/30">
        {title}
      </h2>
      {help && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                className="absolute top-3 right-3 rounded-full p-1 text-cede-text-secondary transition-colors hover:bg-cede-primary/10 hover:text-cede-primary"
                aria-label="Help information"
              >
                <HelpCircle className="w-4 h-4" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="bottom" align="end" className="max-w-[300px] text-sm p-2">
              {help}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
      <div className="relative z-base flex flex-col gap-2">{children}</div>
    </div>
  );
}
